import React from 'react';
import { Table, Header, Segment, Button, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoCurrentSemesterCourses = () => <p><FormattedMessage id="student.noCurrentSemesterCourses" /></p>;


export default class CurrentSemesterCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            error: false
        };
    }

    componentDidMount() {
        axios.get('/students/courses/current')
            .then(res => {
                this.setState({ data: res.data.sort((a, b) => b.mandatory - a.mandatory), loading: false });
            })
            .catch(err => {
                if (err.response.data === 'Did not find unique student study program semester!') {
                    this.setState({ error: true, loading: false });
                }
            });
    }

    render() {
        const { data } = this.state;
        return (
            <div>
                <Header as="h1"><FormattedMessage id="student.currentSemesterCourses" /></Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <FormattedMessage id="common.coursesList" />
                        </Header>
                    </Segment>
                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                        this.state.error ?
                            <Segment>
                                <FormattedMessage id="student.noCurrentSemesterMessage" />
                            </Segment>
                            : <Segment >
                                {data.length ?
                                    <Table tablet celled selectable compact stackable>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell colSpan={4}><FormattedMessage id="common.course" /></Table.HeaderCell>
                                                <Table.HeaderCell width={2}><FormattedMessage id="common.courseCode" /></Table.HeaderCell>
                                                <Table.HeaderCell width={1}>ECTS</Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.lectureExerciseSeminar" /></Table.HeaderCell>
                                                <Table.HeaderCell><FormattedMessage id="common.courseType" /></Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {data.map(row => (
                                                <Table.Row key={row.courseImplementationId}>
                                                    <Table.Cell colSpan={4} verticalAlign="middle">{row.courseName}</Table.Cell>
                                                    <Table.Cell verticalAlign="middle" width={2}>{row.code}</Table.Cell>
                                                    <Table.Cell verticalAlign="middle" width={1}>{row.ects}</Table.Cell>
                                                    <Table.Cell verticalAlign="middle">{row.lectureHours} + {row.exerciseHours} + {row.seminarHours ? row.seminarHours : '0'}</Table.Cell>
                                                    <Table.Cell verticalAlign="middle" width={2}>{row.mandatory ? <FormattedMessage id="common.mandatory" /> : <FormattedMessage id="common.optional" />}</Table.Cell>
                                                </Table.Row>
                                            ))}
                                        </Table.Body>
                                    </Table>
                                    : <NoCurrentSemesterCourses />
                                }
                            </Segment>}
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentCoursesOverview/CurrentSemesterCourses.js